import Button from 'reactstrap/lib/Button';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import Currency from 'Lib/components/common/Currency';
import Date from 'Lib/components/common/Date';
import Phone from 'Lib/components/common/Phone';
// Read Only components
import Text from 'Lib/components/common/Text';
import CurrencyField from 'Lib/components/form/CurrencyField';
import DatePickerField from 'Lib/components/form/DatePickerField';
import IntegerField from 'Lib/components/form/IntegerField';
import PhoneField from 'Lib/components/form/PhoneField';
import RadioField from 'Lib/components/form/RadioField';
import SelectField from 'Lib/components/form/SelectField';
import TextAreaField from 'Lib/components/form/TextAreaField';
// Input components
import TextField from 'Lib/components/form/TextField';
import ToggleField from 'Lib/components/form/ToggleField';
import ApplicationFieldTypes from 'Lib/constants/screening/applicationFieldTypes';

const ApplicationField = props => {
    const { components = {}, isGeneric = false, editSocial, field, index, readOnly, steps, ssn, ssnLoading, ssnShowable = true, templateID, allowSSN = true, ...rest } = props;

    let value = props.value;
    const mappedOptions = field?.options
        ? field.options.map(option => ({
              label: option,
              value: option
          }))
        : [];

    const required = field.isRequired == '1' || field.isRequired;
    const label = field.label ? field.label : field.name;
    const isStateField = field.fieldTypeID == ApplicationFieldTypes.State;

    let Input = () => null;

    switch (parseInt(field.fieldTypeID)) {
        case ApplicationFieldTypes.SocialSecurity:
            if (!allowSSN) return null;

            value = ssn ? ssn : `XXX-XX-${value}`;

            if (readOnly) {
                return (
                    <dl>
                        <dt>{label}</dt>
                        <dd>
                            <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                <Text value={value} />

                                {ssnShowable && (
                                    <Button disabled={ssnLoading} onClick={editSocial}>
                                        {ssnLoading ? 'Loading...' : !ssn ? 'View' : 'Edit'}
                                    </Button>
                                )}
                            </div>
                        </dd>
                    </dl>
                );
            } else if (steps || templateID) Input = TextField;
            else return null;
            break;
        case ApplicationFieldTypes.Text:
        case ApplicationFieldTypes.Hidden:
        case ApplicationFieldTypes.Signature:
        case ApplicationFieldTypes.Email:
            // section.id == ApplicationSections.ApplyingFor && !isEmpty(genericAddress)
            if (readOnly) Input = Text;
            else Input = isGeneric && field.name == 'address' ? components.UnitField : TextField;
            break;
        case ApplicationFieldTypes.TextArea:
            if (readOnly) Input = Text;
            else Input = TextAreaField;
            break;
        case ApplicationFieldTypes.State:
            if (readOnly) Input = Text;
            else Input = components.StateField ? components.StateField : TextField;
            break;
        case ApplicationFieldTypes.Country:
            if (readOnly) Input = Text;
            else Input = components.CountryField ? components.CountryField : TextField;
            break;
        case ApplicationFieldTypes.Toggle:
            if (readOnly) Input = Text;
            else Input = ToggleField;
            break;
        case ApplicationFieldTypes.DatePicker:
            if (readOnly) Input = Date;
            else Input = DatePickerField;
            break;
        case ApplicationFieldTypes.Radio:
            if (readOnly) Input = Text;
            else Input = RadioField;
            break;
        case ApplicationFieldTypes.Term:
            return (
                <Row style={{ marginBottom: '24px' }}>
                    <Col md="8">
                        <div
                            style={{
                                paddingRight: '30px',
                                marginTop: '12px'
                            }}
                        >
                            {required ? label.concat(' *') : label}
                        </div>
                    </Col>
                    <Col md="4">
                        {readOnly ? (
                            <Text value={value && value[index]?.initials} />
                        ) : (
                            <TextField
                                {...rest}
                                className="signature"
                                id={`${rest.id}[${index}].initials`}
                                name={`${rest.id}[${index}].initials`}
                                label={required ? 'Initials'.concat(' *') : 'Initials'}
                            />
                        )}
                    </Col>
                </Row>
            );
        case ApplicationFieldTypes.Question: {
            return (
                <Row style={{ marginBottom: '24px' }}>
                    <Col md="4">
                        <div
                            style={{
                                paddingRight: '30px',
                                marginTop: '12px'
                            }}
                        >
                            {required ? label.concat(' *') : label}
                        </div>
                    </Col>
                    <Col md="4">
                        {readOnly ? (
                            <Text value={value && value[index]?.answer} />
                        ) : (
                            <div style={{ display: 'flex' }}>
                                <RadioField
                                    {...rest}
                                    id={`${rest.id}[${index}].answer_yes`}
                                    name={`${rest.id}[${index}].answer`}
                                    label={required ? field.options[0].concat(' *') : field.options[0]}
                                    value={field.options[0]}
                                />
                                <RadioField
                                    {...rest}
                                    id={`${rest.id}[${index}].answer_no`}
                                    name={`${rest.id}[${index}].answer`}
                                    label={required ? field.options[1].concat(' *') : field.options[1]}
                                    value={field.options[1]}
                                />
                            </div>
                        )}
                    </Col>
                    <Col md="4">
                        {readOnly ? (
                            <Text value={value && value[index]?.reason} />
                        ) : (
                            <TextAreaField
                                {...rest}
                                id={`${rest.id}[${index}].reason`}
                                name={`${rest.id}[${index}].reason`}
                                label={required ? 'Reason *' : 'Reason'}
                                placeholder="Reason"
                            />
                        )}
                    </Col>
                </Row>
            );
        }
        case ApplicationFieldTypes.DropDown:
            if (readOnly) Input = Text;
            else Input = SelectField;
            break;
        case ApplicationFieldTypes.Currency:
            if (readOnly) Input = Currency;
            else Input = CurrencyField;
            break;
        case ApplicationFieldTypes.Integer:
        case ApplicationFieldTypes.Numeric:
            if (readOnly) Input = Text;
            else Input = IntegerField;
            break;
        case ApplicationFieldTypes.Phone:
            if (readOnly) Input = Phone;
            else Input = PhoneField;
            break;
        default:
            break;
    }

    if (readOnly) {
        // Omit passing of unknown properties to HTML elements
        // Pass through countryID field even though it is unknown property
        // because it is required for StateField to work properly
        const { onBlurRaw, countryID, ...attrs } = rest;

        return (
            <dl>
                <dt>{label}</dt>
                <dd>
                    <Input {...attrs} label={required ? label.concat(' *') : label} options={mappedOptions} value={value} />
                </dd>
            </dl>
        );
    } else {
        // Omit passing of unknown properties to HTML elements
        // Pass through countryID field even though it is unknown property
        // because it is required for StateField to work properly
        const { onBlurRaw, countryID, ...attrs } = rest;

        return (
            <Input
                {...attrs}
                label={required ? label.concat(' *') : label}
                options={mappedOptions}
                value={value}
                trim={parseInt(field.fieldTypeID) == ApplicationFieldTypes.Email}
                onBlurRaw={onBlurRaw}
                {...(isStateField ? { countryID: countryID } : {})}
            />
        );
    }
};

export default ApplicationField;
